import { errorResponse, successResponse } from "../api-interface";
import apiService from "../api-service";

export async function uploadFileToApi(
  file: File,
  // WorkGroupId: string,
  ClientId: string,
  Origin: string,
  accessToken?: string,
  onUploadProgress?: (progressEvent: any) => void,
) {
  const formData = new FormData();
  formData.append("file", file);
  // formData.append("WorkGroupId", WorkGroupId ?? "");
  formData.append("ClientId", ClientId ?? "");
  formData.append("Origin", Origin ?? "");

  try {
    const response: any = await apiService.post({
      url: "filestorage/upload",
      data: formData,
      baseUrlKey: "platformServiceUrl",
      accessToken,
      axiosConfig: onUploadProgress
        ? {
            onUploadProgress,
          }
        : undefined,
    });

    if (response?.data) {
      if (response.data[0].error) {
        return errorResponse(`Upload failed: ${response.data[0].error}`);
      } else {
        return successResponse(response.data); // Return success response with data
      }
    } else {
      return errorResponse(`Upload failed: network connection issue`);
    }
  } catch (error: any) {
    return errorResponse(`Upload failed: ${error?.message || String(error)}`);
  }
}

export async function createTasksApi(data: any) {
  try {
    const response: any = await apiService.post(
      "/tasks",
      data,
      "apiUrl",
      //   accessToken,
    );

    if (response?.data) {
      if (response.data[0].error) {
        return errorResponse(`Creating task failed: ${response.data[0].error}`);
      } else {
        return response.data;
      }
    } else {
      return errorResponse(`Creating task failed: network connection issue`);
    }
  } catch (error: any) {
    return errorResponse(
      `Creating task failed: ${error?.message || String(error)}`,
    );
  }
}

/**
 * Download frame image by docId
 * @param docId - Document ID of the frame to download
 * @param clientId - Client ID for the platform file store (optional, defaults from env)
 * @param accessToken - Optional access token for authentication
 * @returns Blob URL of the downloaded image
 */
export async function downloadFrameImage(
  docId: string,
  clientId?: string,
  accessToken?: string,
  isHyperlink?: boolean,
): Promise<string | null> {
  if (!docId || !docId.trim()) {
    console.error("docId must not be blank");
    return null;
  }

  // Use provided clientId or fallback to env variable
  const fileClientId =
    clientId ||
    import.meta.env.VITE_FILE_CLIENT_ID ||
    "46f836d6-dc07-4e87-94d8-fde07087ebd4";

  try {
    const response: any = await apiService.get({
      url: `filestorage/download/${docId}/${fileClientId}`,
      baseUrlKey: "platformServiceUrl",
      accessToken,
      axiosConfig: {
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      },
    });

    if (response?.data) {
      // Create blob URL from response
      const blob = new Blob([response.data], {
        type: isHyperlink
          ? "image/png"
          : response.headers["content-type"] || "image/png",
      });
      return URL.createObjectURL(blob);
    } else {
      console.error(`Download failed for docId: ${docId}`);
      return null;
    }
  } catch (error: any) {
    console.error(
      `Download failed for docId ${docId}:`,
      error?.message || String(error),
    );
    return null;
  }
}

/**
 * Get SAS URL for a frame by docId (for blur pixelation check)
 * @param docId - Document ID of the frame (blob_id)
 * @param accessToken - Access token for authentication
 * @returns SAS URL string or null if failed
 */
export async function getFrameSasUrl(
  docId: string,
  accessToken?: string,
): Promise<string | null> {
  if (!docId || !docId.trim()) {
    console.error("docId must not be blank");
    return null;
  }

  try {
    const response: any = await apiService.post({
      url: "dfd/get_sas_url",
      data: { blob_id: docId },
      baseUrlKey: "dfdApiUrl",
      accessToken,
    });

    if (response?.data?.sas_url) {
      return response.data.sas_url;
    } else {
      console.error(
        `SAS URL response did not contain 'sas_url'. Response:`,
        response?.data,
      );
      return null;
    }
  } catch (error: any) {
    console.error(
      `Failed to get SAS URL for docId ${docId}:`,
      error?.message || String(error),
    );
    return null;
  }
}
